import { Amplify } from 'aws-amplify';

import { CONFIG } from 'src/global-config';

// ----------------------------------------------------------------------

let configured = false;

export function configureAmplify(): boolean {
  if (configured) {
    return true;
  }

  const { userPoolId, userPoolWebClientId, region } = CONFIG.amplify;

  if (!userPoolId || !userPoolWebClientId || !region) {
    return false;
  }

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId,
        userPoolClientId: userPoolWebClientId,
      },
    },
  });

  configured = true;
  return true;
}
